var _RecognitionManager_instances, _RecognitionManager_config, _RecognitionManager_isAccessTokenExpired, _RecognitionManager_isRefreshTokenExpired, _RecognitionManager_isAccessTokenExpiring, _RecognitionManager_checkAndReauthenticate, _RecognitionManager_isRedirectToSignInEnabled, _RecognitionManager_forceReautenticate;
import { __awaiter, __classPrivateFieldGet, __classPrivateFieldSet, __decorate } from "tslib";
import { singleton } from 'tsyringe';
import Cookies from 'js-cookie';
export const DEFAULT_RECOGNITION_CONFIG = {
    isEnabled: true,
    forceRedirectToSignIn: true,
    disableRedirectForPages: [],
    forceReautenticate: true,
    signInUrl: '',
    reauthenticateUrl: '',
    refreshTokenInterval: 5 * 60 * 1000, // 5 minutes
};
const COOKIE_NAME = 'IO_SESSION';
let RecognitionManager = class RecognitionManager {
    constructor() {
        _RecognitionManager_instances.add(this);
        _RecognitionManager_config.set(this, void 0);
    }
    init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            config.recognition = Object.assign(Object.assign({}, DEFAULT_RECOGNITION_CONFIG), config.recognition);
            __classPrivateFieldSet(this, _RecognitionManager_config, config, "f");
            __classPrivateFieldGet(this, _RecognitionManager_instances, "m", _RecognitionManager_checkAndReauthenticate).call(this);
            __classPrivateFieldGet(this, _RecognitionManager_instances, "m", _RecognitionManager_forceReautenticate).call(this);
        });
    }
    getAccessToken() {
        const credentials = this.getCredentials();
        return credentials === null || credentials === void 0 ? void 0 : credentials.accessToken;
    }
    getRefreshToken() {
        const credentials = this.getCredentials();
        return credentials === null || credentials === void 0 ? void 0 : credentials.refreshToken;
    }
    setCredentials(credentials) {
        credentials.createdAt = Date.now();
        Cookies.set(COOKIE_NAME, JSON.stringify(credentials), {
            domain: '.descomplica.com.br',
            path: '/',
            expires: 365, // 1 year
        });
    }
    getCredentials() {
        try {
            const cookieValue = Cookies.get(COOKIE_NAME);
            if (!cookieValue)
                return null;
            const credentials = JSON.parse(cookieValue);
            const { createdAt, expiresIn } = credentials;
            const now = Date.now();
            const accessTokenExpiresAt = createdAt + expiresIn * 1000;
            if (now >= accessTokenExpiresAt) {
                return null;
            }
            return credentials;
        }
        catch (error) {
            return null;
        }
    }
    clearCredentials() {
        Cookies.remove(COOKIE_NAME, {
            domain: '.descomplica.com.br',
            path: '/',
        });
    }
    goToSignIn() {
        if (!__classPrivateFieldGet(this, _RecognitionManager_instances, "m", _RecognitionManager_isRedirectToSignInEnabled).call(this)) {
            return;
        }
        const signInUrl = __classPrivateFieldGet(this, _RecognitionManager_config, "f").recognition.signInUrl;
        const domain = window.location.hostname;
        const acceptedDomains = ['localhost', '.descomplica.com.br', '.descomplica.io'];
        if (!acceptedDomains.some((acceptedDomain) => domain.endsWith(acceptedDomain))) {
            window.location.href = signInUrl;
            return;
        }
        const redirectUrl = window.location.href;
        window.location.href = `${signInUrl}?redirect_url=${redirectUrl}`;
    }
    reauthenticate() {
        return __awaiter(this, void 0, void 0, function* () {
            const credentials = this.getCredentials();
            if (!credentials)
                return;
            const { refreshToken } = credentials;
            const response = yield fetch(__classPrivateFieldGet(this, _RecognitionManager_config, "f").recognition.reauthenticateUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    refreshToken,
                }),
            });
            if (response.status === 200) {
                const credentialsDto = yield response.json();
                this.setCredentials(credentialsDto.data);
            }
            else {
                this.clearCredentials();
                this.goToSignIn();
            }
        });
    }
};
_RecognitionManager_config = new WeakMap(), _RecognitionManager_instances = new WeakSet(), _RecognitionManager_isAccessTokenExpired = function _RecognitionManager_isAccessTokenExpired() {
    const credentials = this.getCredentials();
    if (!credentials)
        return true;
    const { expiresIn, createdAt } = credentials;
    const now = Date.now();
    const accessTokenExpiresAt = createdAt + expiresIn * 1000;
    return now >= accessTokenExpiresAt;
}, _RecognitionManager_isRefreshTokenExpired = function _RecognitionManager_isRefreshTokenExpired() {
    const credentials = this.getCredentials();
    if (!credentials)
        return true;
    const { refreshExpiresIn, createdAt } = credentials;
    const now = Date.now();
    const refreshTokenExpiresAt = createdAt + refreshExpiresIn * 1000;
    return now >= refreshTokenExpiresAt;
}, _RecognitionManager_isAccessTokenExpiring = function _RecognitionManager_isAccessTokenExpiring() {
    const credentials = this.getCredentials();
    if (!credentials)
        return false;
    const { expiresIn, createdAt } = credentials;
    const now = Date.now();
    const accessTokenExpiresAt = createdAt + expiresIn * 1000;
    return accessTokenExpiresAt - now < 5 * 60 * 1000; // 5 minutes
}, _RecognitionManager_checkAndReauthenticate = function _RecognitionManager_checkAndReauthenticate() {
    const isAccessTokenExpired = __classPrivateFieldGet(this, _RecognitionManager_instances, "m", _RecognitionManager_isAccessTokenExpired).call(this);
    const isRefreshTokenExpired = __classPrivateFieldGet(this, _RecognitionManager_instances, "m", _RecognitionManager_isRefreshTokenExpired).call(this);
    const isAccessTokenExpiring = __classPrivateFieldGet(this, _RecognitionManager_instances, "m", _RecognitionManager_isAccessTokenExpiring).call(this);
    if (isRefreshTokenExpired) {
        this.clearCredentials();
        this.goToSignIn();
        return;
    }
    if (isAccessTokenExpired || isAccessTokenExpiring) {
        this.reauthenticate();
        return;
    }
}, _RecognitionManager_isRedirectToSignInEnabled = function _RecognitionManager_isRedirectToSignInEnabled() {
    const { disableRedirectForPages, forceRedirectToSignIn } = __classPrivateFieldGet(this, _RecognitionManager_config, "f").recognition;
    if (!forceRedirectToSignIn)
        return false;
    if (!disableRedirectForPages)
        return true;
    const pathname = window.location.pathname;
    return !disableRedirectForPages.some((page) => pathname.startsWith(page));
}, _RecognitionManager_forceReautenticate = function _RecognitionManager_forceReautenticate() {
    var _a, _b;
    if ((_a = __classPrivateFieldGet(this, _RecognitionManager_config, "f").recognition) === null || _a === void 0 ? void 0 : _a.forceReautenticate) {
        const interval = ((_b = __classPrivateFieldGet(this, _RecognitionManager_config, "f").recognition) === null || _b === void 0 ? void 0 : _b.refreshTokenInterval) || 5 * 60 * 1000;
        setInterval(() => {
            __classPrivateFieldGet(this, _RecognitionManager_instances, "m", _RecognitionManager_checkAndReauthenticate).call(this);
        }, interval);
    }
};
RecognitionManager.InvalidTokenError = 'InvalidToken';
RecognitionManager.UnauthorizedError = 'Unauthorized';
RecognitionManager.UnauthenticatedError = 'Unauthenticated';
RecognitionManager.ForbiddenError = 'Forbidden';
RecognitionManager = __decorate([
    singleton()
], RecognitionManager);
export { RecognitionManager };
